import React from 'react';
import styled from 'styled-components';
import { colors, dimensions } from '../../common/styles';
// import { colors, dimensions } from 'modules/common/styles';
import QuickNavigation from '../containers/QuickNavigation';

const TopBar = styled.div`
  height: 100%;
  // display: flex;
  // justify-content: flex-end;
  // align-items: center;
  // margin: 0;
  // border: 0;
  // flex-shrink: 0;
  // padding: 0 ${dimensions.coreSpacing}px;
  // background: ${colors.colorWhite};
  // // box-shadow: 0 1px 6px ${colors.colorShadowGray};
  // box-shadow: 0px 4px 4px 0px #0000000A;
  // position: fixed;
  // left: 0;
  // right: 0;
  // top: 0;
  // z-index: 1;
`;

function MainBar() {
  return (
    <TopBar>
      <QuickNavigation />
    </TopBar>
  );
}

export default MainBar;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/MainBar.js